<template>
  <game-template title="Trouvez la bonne signification pour chaque sigle">
    <template v-slot:content>
      <div class="quizz-wrapper">
        <quizz
          :custom-question="true"
          :show-index="false"
          :question="currentQuestion"
          :question-name="currentQuestionLabel"
          :nb-question="questions.length"
          :index="questionIndex"
          @answered="setQuestionStatus"
          @next-question="nextQuestion">
          <template v-slot:custom-question>
            <div class="question">
              <transition name="fade" mode="out-in">
                <p class="title" v-if="currentQuestion.status === 'remaining'">
                  {{ currentQuestion.question }}
                </p>
                <div v-else>
                  <p  class="title full-title" v-html="currentQuestion.fullLabel"></p>
                  <p class="definition" v-html="currentQuestion.definition"></p>
                </div>
              </transition>
            </div>
          </template>
        </quizz>
      </div>
    </template>
  </game-template>
</template>

<script>
import stepMixin from '@shared/mixins/stepMixin'
import quizzMixin from '@shared/mixins/quizzMixin'
import Quizz from '@shared/components/Quizz'

export default {
  name: 'SigleQuizz',
  mixins: [stepMixin, quizzMixin],
  components: {
    Quizz
  },
  data () {
    return {
      questionIndex: 0,
      questions: [
        {
          name: 'q1',
          question: 'DCP',
          fullLabel: '<span>D</span>roit aux <span>C</span>ongés <span>P</span>ayés',
          definition: 'Le droit aux congés payés est composé des congés payés légaux acquis et à venir, des éventuels jours de fractionnement et/ou reportés.',
          answers: [
            {
              name: 'a',
              label: 'Droit aux Congés Payés',
              isValid: true
            },
            {
              name: 'b',
              label: 'Don de Congés Payés',
              isValid: false
            },
            {
              name: 'c',
              label: 'Données à Caractère Personnel',
              isValid: false
            }
          ],
          status: 'remaining'
        },
        {
          name: 'q2',
          question: 'DRT',
          fullLabel: '<span>D</span>roit aux <span>RT</span>T',
          definition: 'RTT signifie « Réduction du Temps de travail ».<br/>' +
            'Les RTT sont acquis en compensation d\'heures effectuées au-delà des 35 h par semaine ou dans le cadre de convention de forfait jours.',
          answers: [
            {
              name: 'a',
              label: 'Directives Reglementaires relatives au Temps de travail',
              isValid: false
            },
            {
              name: 'b',
              label: 'Don Rétroactif de Temps',
              isValid: false
            },
            {
              name: 'c',
              label: 'Droit aux RTT',
              isValid: true
            }
          ],
          status: 'remaining'
        },
        {
          name: 'q4',
          question: 'DSC',
          fullLabel: '<span>D</span>on <span>S</span>olidaire de <span>C</span>ongé',
          definition: 'Pour un contexte bien précis, des collaborateurs peuvent faire don de congé payé, de RTT ou d\'heures.',
          answers: [
            {
              name: 'a',
              label: 'Don Solidaire de Congé',
              isValid: true
            },
            {
              name: 'b',
              label: 'Droit aux heures de gestion  Syndicales et Collectives',
              isValid: false
            },
            {
              name: 'c',
              label: 'Droit Supplémentaire aux Congés',
              isValid: false
            }
          ],
          status: 'remaining'
        },
        {
          name: 'q5',
          question: 'DHER1',
          fullLabel: '<span>D</span>roit en <span>He</span>ure à <span>R</span>écupérer (ou à payer) à <span>100%</span>',
          definition: 'Lorsqu’un salarié effectue des heures excédentaires sans dépasser son horaire hebdomadaire , elles sont à 100% et stockées dans le DHER1.<br/>Les heures peuvent être récupérées et/ou payées.',
          answers: [
            {
              name: 'a',
              label: 'Droit en Heure à Récupérer (ou à payer) à 100%',
              isValid: true
            },
            {
              name: 'b',
              label: 'Droit en Heure à Récupérer (ou à payer) à 125%',
              isValid: false
            },
            {
              name: 'c',
              label: 'Droit en Heure à Récupérer (ou à payer) à 150%',
              isValid: false
            }
          ],
          status: 'remaining'
        },
        {
          name: 'q6',
          question: 'DHER2',
          fullLabel: '<span>D</span>roit en <span>He</span>ure à <span>R</span>écupérer (ou à payer) à <span>125%</span>',
          definition: 'Lorsqu’un salarié effectue des heures excédentaires en dépassant de moins de 8 h son horaire hebdomadaire elles sont à 125 % et stockées dans le DHER 2.<br/>Les heures peuvent être récupérées et/ou payées. Les heures payées s’imputent au contingent.',
          answers: [
            {
              name: 'a',
              label: 'Droit en Heure à Récupérer (ou à payer) à 100%',
              isValid: false
            },
            {
              name: 'b',
              label: 'Droit en Heure à Récupérer (ou à payer) à 125%',
              isValid: true
            },
            {
              name: 'c',
              label: 'Droit en Heure à Récupérer (ou à payer) à 150%',
              isValid: false
            }
          ],
          status: 'remaining'
        },
        {
          name: 'q7',
          question: 'DHER3',
          fullLabel: '<span>D</span>roit en <span>He</span>ure à <span>R</span>écupérer (ou à payer) à <span>150%</span>',
          definition: 'Lorsqu’un salarié effectue des heures excédentaires en dépassant d’au moins 8 h son horaire hebdomadaire elles sont à 150% et stockées dans le DHER 3.<br/>Les heures peuvent être récupérées et/ou payées. Les heures payées s’imputent au contingent.',
          answers: [
            {
              name: 'a',
              label: 'Droit en Heure à Récupérer (ou à payer) à 100%',
              isValid: false
            },
            {
              name: 'b',
              label: 'Droit en Heure à Récupérer (ou à payer) à 125%',
              isValid: false
            },
            {
              name: 'c',
              label: 'Droit en Heure à Récupérer (ou à payer) à 150%',
              isValid: true
            }
          ],
          status: 'remaining'
        },
        {
          name: 'q8',
          question: 'ICT',
          fullLabel: '<span>C</span>ontingent d\'heures supplémentaires',
          definition: 'En fonction de l\'accord en vigeur, le salarié peut percevoir un maximum d\'heures supplémentaires par an.<br/>' +
            'À chaque paiement d\'heures supplémentaires (125% et 150%), le contingent diminue. ',
          answers: [
            {
              name: 'a',
              label: 'Contingent d\'heures supplémentaires',
              isValid: true
            },
            {
              name: 'b',
              label: 'Incident sur les Congés et les Temps de travail',
              isValid: false
            },
            {
              name: 'c',
              label: 'Incident au Compteur de Temps',
              isValid: false
            }
          ],
          status: 'remaining'
        },
        {
          name: 'q9',
          question: 'DCOR',
          fullLabel: '<span>D</span>roit <span>C</span>ompensateur <span>O</span>bligatoire en <span>R</span>epos',
          definition: 'Lorsque le contingent d\'heures supplémentaires est dépassé, toutes nouvelles heures supplémentaires donnent droit à la majoration légale et à un repos équivalent à 100%. L\'accord des partenaires sociaux est obligatoire.',
          answers: [
            {
              name: 'a',
              label: 'Droit aux Congés et Obligation de Repos',
              isValid: false
            },
            {
              name: 'b',
              label: 'Droit Commun et Obligatoire au Repos',
              isValid: false
            },
            {
              name: 'c',
              label: 'Droit Compensateur Obligatoire en Repos',
              isValid: true
            }
          ],
          status: 'remaining'
        },
        {
          name: 'q10',
          question: 'DRC2',
          fullLabel: '<span>D</span>roit en <span>R</span>epos <span>C</span>ompensateur de nuit',
          definition: 'Les collaborateurs ayant des horaires réguliers de nuit acquièrent 15min de repos toutes les 8h de nuit (consécutives ou non).',
          answers: [
            {
              name: 'a',
              label: 'Droit en repos compensateur du dimanche',
              isValid: false
            },
            {
              name: 'b',
              label: 'Droit en repos compensateur de nuit',
              isValid: true
            },
            {
              name: 'c',
              label: 'Droit en repos compensateur des jours fériés',
              isValid: false
            }
          ],
          status: 'remaining'
        },
        {
          name: 'q11',
          question: 'DHEM',
          fullLabel: '<span>D</span>roit pour la <spans>M</span>odulation (en <span>HE</span>ure)',
          definition: 'Uniquement pour les organisations du temps de travail en modulation/annualisation.<br/>' +
            'Le compteur permet de suivre le nombre d\'heures à faire et fait à l\'année, de gérer les récupérations et les paiements pendant l\'année. Les heures payées s’imputent au contingent.',
          answers: [
            {
              name: 'a',
              label: 'Droit pour la modulation (en heure)',
              isValid: true
            },
            {
              name: 'b',
              label: 'Déclaration des Heures Excédentaires Mensuelles',
              isValid: false
            },
            {
              name: 'c',
              label: 'Déduction des heures Effectuées',
              isValid: false
            }
          ],
          status: 'remaining'
        }
      ]
    }
  }
}
</script>

<style lang="scss">
.quizz-wrapper {
  padding: 10px 128px 20px 128px;
  .quizz .question-bloc .question {
    .title {
      font-size: 1.75rem;
      &.full-title {
        font-weight: 300;
        span {
          font-weight: 700;
        }
      }
    }
    .definition {
      margin-top: 35px;
      text-align: center;
      font-weight: 400;
      font-size: 1rem;
      line-height: 1.4rem;
    }
  }
}
</style>
